/*
自定义的axios 第3个参数（config）字段意义：
{
showError:   默认弹出toast框提示。showError='alert'表示弹出alert框。showError===false默认不弹出
noToken：    true表示请求时，不在header中带入token。默认带入
maskOptions:  表示请求时显示遮罩层的选项。默认{body: true}
}

*/

import Axios from 'axios'
import msgDlg from './utils/msgDialog'
import loading from './utils/loading'
import kygMsg from './kygMsg';
import $x from './$x';

const serverMap = require('../../config/serverMap.js')

const axios = Axios.create({
    baseURL: serverMap.domain + 'api/',
    withCredentials: true,
    timeout: 20000
})
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.transformRequest = function (request) {
    return JSON.stringify(request)
}

const CoveredErrMsg = kygMsg(320818, '系统异常,请联系管理员。')
// http请求拦截器
axios.interceptors.request.use(function (config) {
    //将 {node_api}/xxx/yyy 的url替换为对应服务的前缀
    config.url = config.url.replace(/^\{(\w+)\}/, (m, $1) => serverMap[$1] || '');

    //遮罩层
    loading.show(config.maskOptions || { unclickable: true })

    return config
}, fail)

// http响应拦截器
axios.interceptors.response.use(function (res) {
    loading.close(res.config.maskOptions);
    const obj = res.data || {};
    return parseRes(obj, res);
}, fail);

function parseRes(obj, res) {
    const retCode = Number(obj.msgid);
    if (retCode == 1) { // token失败
        return new Promise((resolve, reject) => {
            msgDlg.toast(kygMsg(900146, '长时间未操作，系统强制退出，请重新登录!'))
            setTimeout(doLogin, 1500)
            reject(obj)
        });
    } else if (retCode != 0) { //错误或提示
        if (retCode == 2) obj.msg = CoveredErrMsg //系统异常
        showErr(res.config, obj.msg);
        return Promise.reject(obj)
    }
    return obj.data
}

axios.parseRes = parseRes
axios.doLogin = doLogin

function doLogin(toHome) {
    let url = serverMap.domain + 'AppLogin.aspx';
    let backUrl = location.href;
    let query = backUrl.split('?')[1];
    backUrl = backUrl.split('#')[0] + '#/';

    query = query ? '&' + query.split('#')[0] : '';

    if (backUrl && url.indexOf('targeturl') === -1) {
        url += url.indexOf('?') > -1 ? '&' : '?';
        url += 'targeturl=' + encodeURIComponent(backUrl) + query
    }

    $x.storage.setObj('loginState', null);
    location.href = url
}

function fail(error) {
    if (error.config) loading.close(error.config.maskOptions);
    if (!error.errmsg) error.errmsg = CoveredErrMsg;
    showErr(error.config, CoveredErrMsg);
    console.error(error)
    return Promise.reject(error)
}

function showErr(config, errmsg) {
    if (errmsg) {
        if (config && config.showError === 'alert')
            msgDlg.alert(errmsg, { type: 'error' });
        else
            msgDlg.toast.error(errmsg);
    }
}

export default axios
